import { logEvent } from '@/utils/analytics';
import { getAppInstance } from '@/utils/api/app';
import { useQuery } from '@tanstack/react-query';
import type { ApplicationResponseV2 } from '@/services';
import amplitudeEvents from '@/utils/amplitudeEvents.json' with { type: 'json' };

export const getApplicationsWithPublicIdQueryFn = async (publicId: string) =>
  getAppInstance()
    .get<ApplicationResponseV2>(`/applications-with-publicId?publicId=${publicId}`)
    .then((response) => response.data);

export function useApplications(publicId: string | null) {
  logEvent(amplitudeEvents.APPLICATIONS_WITH_PUBLIC_ID_HOOK, { publicId });
  return useQuery({
    queryFn: () => getApplicationsWithPublicIdQueryFn(publicId!) as Promise<ApplicationResponseV2>,
    queryKey: ['getApplicationsWithPublicIdQueryFn', publicId],
    enabled: !!publicId,
  });
}
